export const commonBoxShadowStyle = {
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
};

export const commonBoxShadowHoverStyle = {
  boxShadow: "rgb(0 0 0 / 50%) 0px 2px 8px",
};

export const commonBoxShadowStyleByOpacity = (op: string) => ({
  boxShadow: `0px 2px 8px rgba(0, 0, 0, ${op})`,
});

export const bottomActionAreaBoxShadow = {
  boxShadow: "0px -3px 7px rgba(0, 0, 0, 0.05)",
};
